import { useMemo } from 'react';
import { Offer, TarifficatorPurchaseSuccessWidgetEvent } from '@funtech-int/yango-shared';

import { useSendWebAnalytics } from '@/shared/hooks/useSendWebAnalytics';

const CLICK_OFFER_BUTTON = 'ClickOfferButton';
const SHOW_OFFER_BUTTON = 'ShowOfferButton';
const BUY_SUBSCRIPTION_SUCCESS = 'BUY_SUBSCRIPTION_SUCCESS';

const getShowEventName = (eventAffix?: string) => {
    if (eventAffix) {
        return `${SHOW_OFFER_BUTTON}.${eventAffix}`;
    }

    return SHOW_OFFER_BUTTON;
};

const getClickEventName = (eventAffix?: string) => {
    if (eventAffix) {
        return `${CLICK_OFFER_BUTTON}.${eventAffix}`;
    }

    return CLICK_OFFER_BUTTON;
};

const getSuccessEventName = (eventAffix?: string) => {
    if (eventAffix) {
        return `${eventAffix.toUpperCase()}.${BUY_SUBSCRIPTION_SUCCESS}`;
    }

    return BUY_SUBSCRIPTION_SUCCESS;
};

function getUniversalAnalyticsEcommerceData(
    offer?: Offer | null,
    event?: TarifficatorPurchaseSuccessWidgetEvent
) {
    const baseData = {
        transaction_id: offer?.eventSessionId,
    };

    if (!event?.data?.subscriptionValues) {
        return baseData;
    }

    const { subscriptionValues, selectedOption } = event.data;

    return {
        ...baseData,
        sub_values_paid_price: subscriptionValues.paidPrice,
        sub_values_price: subscriptionValues.price,
        sub_values_currency: subscriptionValues.currency,
        sub_values_tariff_name: subscriptionValues.tariffName,
        sub_values_offer_name: subscriptionValues.offerName,
        sub_values_has_trial: subscriptionValues.hasTrial,
        sub_values_trial_duration: subscriptionValues.trialDuration,
        sub_values_has_intro: subscriptionValues.hasIntro,
        sub_values_intro_duration: subscriptionValues.introDuration,
        sub_values_plan_period: subscriptionValues.planPeriod,
        sub_values_promocode_type: subscriptionValues.promocodeType,

        subscription_type: selectedOption?.subscriptionType,
        billing_product_id: selectedOption?.billingProductId,
        monetization_model: selectedOption?.monetizationModel,
        is_trial: selectedOption?.isTrial,
    };
}

export const useOfferWebAnalytics = (offer?: Offer | null) => {
    const sendWebAnalytics = useSendWebAnalytics();

    return useMemo(() => {
        const eventAffix = offer?.offerTexts?.customTexts?.webAnalyticsEventAffix;

        return {
            offerShowed: () => sendWebAnalytics(getShowEventName(eventAffix)),
            offerClicked: () => sendWebAnalytics(getClickEventName(eventAffix)),
            purchaseSucceeded: (event?: TarifficatorPurchaseSuccessWidgetEvent) =>
                sendWebAnalytics(
                    getSuccessEventName(eventAffix),
                    getUniversalAnalyticsEcommerceData(offer, event)
                ),
        };
    }, [offer, sendWebAnalytics]);
};
